import { useChartPeriod } from '@/hooks';
import { tokensMapping } from '@/utils/tokens';
import {
  CurrencyValue,
  formatDatetime,
  formatNumber,
  LineChart
} from '@blockanalitica/ui';
import { useCallback, useMemo } from 'react';

export default function HistoricGraphs({
  data,
  timeFilter,
  chartDaysAgo,
  activeDisplayOption
}) {
  const [chartPeriod, updateChartConfigWithPeriod] =
    useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod();
  const subValueFormatter = useCallback(
    (value: string) => (
      <>
        {chartPeriod.labelPrefix}
        {formatDatetime(value, { format: chartPeriod.dateFormat })}
      </>
    ),
    [chartPeriod]
  );

  const valueFormatter = useMemo(() => {
    function formatValue(value: string) {
      return (
        <CurrencyValue
          value={Number(value)}
          options={{
            currency: tokensMapping('USDS')
          }}
        />
      );
    }

    return formatValue;
  }, []);

  const yScaleValueFormatter = useMemo(() => {
    return (value) => {
      return `${formatNumber(value)}`;
    };
  }, []);

  return (
    <LineChart
      key={activeDisplayOption}
      data={data}
      valueFormatter={valueFormatter}
      datasets={[
        {
          xField: 'date',
          yField: activeDisplayOption
        }
      ]}
      yScaleValueFormatter={yScaleValueFormatter}
      timeFilter={timeFilter}
      config={config}
      subValueFormatter={subValueFormatter}
    />
  );
}
